import { Component, OnInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalService } from '../global.service';
import * as M from "materialize-css/dist/js/materialize";
//import moveDocument from 'node_modules copy/@angular/core/schematics/migrations/move-document';
import * as moment from 'moment';
//import { E } from 'node_modules copy/@angular/cdk/keycodes';

@Component({
	selector: 'unos-izmjena-pregled',
	templateUrl: './unos-izmjena-pregled.component.html',
	styleUrls: ['./unos-izmjena-pregled.component.css']
})
export class UnosIzmjenaPregledComponent implements OnInit {
	@Input() id;
	@Input() autoId;
	@Input() nazivProizvodjaca;
	@Input() regBroj;

	@Output() onInsertPregled = new EventEmitter<any>();
	@Output() onCancel = new EventEmitter<any>();

	constructor(private http: HttpClient, public globalSrvc: GlobalService) { }
	loading = false;
	msg : any;
	tipovi_pregleda : any = [{ 'id': 'A', 'naziv': 'Analogni', jeOdabran: false }, { 'id': 'D', 'naziv': 'Digitalni', jeOdabran: false }];
	mjerniOpsezi : any = [{ 'id': null, 'naziv': '', jeOdabran: false }, { 'id': '100', 'naziv': '100', jeOdabran: false }, { 'id': '125', 'naziv': '125', jeOdabran: false }, { 'id': '140', 'naziv': '140', jeOdabran: false },
							{ 'id': '180', 'naziv': '180', jeOdabran: false },{ 'id': '220', 'naziv': '220', jeOdabran: false },];
	ext_gnss_list : any = [{ 'id': null, 'naziv': '', jeOdabran: false }, { 'id': 'DOSTUPAN', 'naziv': 'DOSTUPAN', jeOdabran: false }, { 'id': 'NEDOSTUPAN', 'naziv': 'NEDOSTUPAN', jeOdabran: false }];

	pregled : any = {id : null, auto_id : null, datum : null, br_zap : null, tip_pregleda : null, tahMakerId : null, tahTip : null, tahSerial : null, dim_pneum : null, pritisak : null, 
		obim_tockova : null, koef_vozila : null, tip_gr_brzine : null, postavljena_brzina : null, konst_prijem_tah : null, konst_podes_tah : null, odometar_dolazak : null, 
		odometar_odlazak : null, etal_uredjaj_id : null, etal_uredjaj_brz_tip : null, etal_uredjaj_brz_serial : null, etal_sat_meh_id : null, etal_sat_meh_tip : null, 
		etal_sat_meh_serial : null, sat_meh_tacnost : null, sat_meh_sat : null, sat_meh_listic : null, sat_meh_razlika : null, ve_etalon_1 : null, ve_etalon_2 : null, ve_etalon_3 : null, 
		vi_tah_1 : null, vi_tah_2 : null, vi_tah_3 : null, de_etalon : null, di_tah : null, br_plombi : null, br_uvjerenja : null, vrsta_pregleda_id : null, tehnicar_id : null, 
		ser_broj_dav_br : null, stanje_odometra : null, konst_tah : null, min_kalib : null, sat_kalib : null, svrha_dig_pregleda_id : null, kartica_tehnicara_id : null, 
		granicnik_brzina_kalib : null, obim_tockova_kalib : null, koef_vozila_kalib : null, mjerni_opseg : null, napomena : null, gnss_ext : null, gnss_ser_broj : null, 
		drcs_ser_broj : null, plomba_ser_broj : null, vrsta_prevoza : null};

	etal_uredjaji : any = [];
	etal_sat_mehi : any = [];
	vrste_pregleda : any = [];
	tehnicari : any = [];
	tahmakers : any = [];
	svrhe_dig_predleda : any = [];
	kartice_tehnicara : any = [];

	err_brojZap = false;
	err_brojZap_poruka = '';
	err_datum = false;
	err_datum_poruka = '';
	err_tip_pregleda = false; 
	err_tip_pregleda_poruka = ''; 
	
	modalInstance : any = null;
	nazivSifrarnika : any = null;	
	sati_pregleda : any = [];
	minuti_pregleda : any = [];

	ngOnInit() {
		this.ucitaj();

		var elems = document.querySelectorAll('.datepicker');
    	var instances = M.Datepicker.init(elems, {format : 'dd.mm.yyyy', 
		i18n: {
			months: ["Januar", "Februar", "Mart", "April", "Maj", "Jun", "Jul", "Avgust", "Septembar", "Octobar", "Novembar", "Decembar"],
			monthsShort: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Avg", "Sep", "Oct", "Nov", "Dec"],
			weekdays: ["Nedjelja","Ponedjeljak", "Utorak", "Srijeda", "Četvrtak", "Petak", "Subota"],
			weekdaysShort: ["Ned", "Pon","Uto", "Sri", "Čet", "Pet", "Sub"],
			weekdaysAbbrev: ["N","P", "U", "S", "Č", "P", "S"]
		}});

		for(let i = 0; i < 10; i++) this.sati_pregleda.push({ 'id': '0' + i});
		for(let i = 10; i < 24; i++) this.sati_pregleda.push({ 'id': '' + i});

		for(let i = 0; i < 10; i++) this.minuti_pregleda.push({ 'id': '0' + i});
		for(let i = 10; i < 60; i++) this.minuti_pregleda.push({ 'id': '' + i});
	}

	server_data : any = null;

	ucitaj() {
		this.loading = true;
		this.http.get('vlasnici/automobili/pregled/detaljno', { params: { id: this.id?this.id:"", auto_id : this.autoId } })
			.subscribe(data => {
				//console.log(data);
				this.loading = false;
				this.pregled = data;
				
				this.etal_uredjaji = this.pregled.etal_uredjaji;
				this.etal_sat_mehi  = this.pregled.etal_sat_mehi;
				this.vrste_pregleda  = this.pregled.vrste_pregleda;
				this.tehnicari  = this.pregled.tehnicari;
				this.tahmakers  = this.pregled.tahmakers;
				this.svrhe_dig_predleda  = this.pregled.svrhe_dig_predleda;
				this.kartice_tehnicara  = this.pregled.kartice_tehnicara;

				this.pregled.etal_uredjaji = [];
				this.pregled.etal_sat_mehi = [];
				this.pregled.vrste_pregleda = [];
				this.pregled.tehnicari = [];
				this.pregled.tahmakers = [];
				this.pregled.svrhe_dig_predleda = [];
				this.pregled.kartice_tehnicara = [];

				setTimeout(() => {
					M.updateTextFields();
				}, 600);
				
				//this.ucitajSkole();
				if (!this.id){
					this.pregled.datum = moment().format('DD.MM.YYYY');
					this.pregled.datum_kalib = moment().format('DD.MM.YYYY');
					this.pregled.tip_pregleda = 'A';
					this.pregled.sat_meh_sat = '03:00';
				}
			}
			, error => {
				this.loading = false;
			});
	}

	toastTimeout = 5000;
	
	tipSelected(event){
		setTimeout(() => {
			M.updateTextFields();
		}, 600);
	}

	uredjajSelected(event){
		let item = this.etal_uredjaji.find((item) => item.id == event.target.value);
		
		if (item && item.id == '1'){
			this.pregled.etal_uredjaj_brz_tip = 'CD 400';
			this.pregled.etal_uredjaj_brz_serial = '56000670';
		}
		else if (item && item.id == '2'){
			this.pregled.etal_uredjaj_brz_tip = 'EB-4';
			this.pregled.etal_uredjaj_brz_serial = '86';
		}
		else if (item && item.id == '3'){
			this.pregled.etal_uredjaj_brz_tip = 'MATRICOLA';
			this.pregled.etal_uredjaj_brz_serial = '17045';
		}
		setTimeout(() => {
			M.updateTextFields();
		}, 200);
	}

	satMehSelected(event){
		let item = this.etal_sat_mehi.find((item) => item.id == event.target.value);
		
		if (item && item.id == '1'){
			this.pregled.etal_sat_meh_tip = 'CD 400';
			this.pregled.etal_sat_meh_serial = '56000670';
		}
		else if (item && item.id == '2'){
			this.pregled.etal_sat_meh_tip = 'MS-1';
			this.pregled.etal_sat_meh_serial = '69';
		}

		setTimeout(() => {
			M.updateTextFields();
		}, 200);
	}

	cancel(){
		if (this.onCancel)
			this.onCancel.emit(null);
	}

	savedata(){
		if (!this.pregled.tip_pregleda) {
			this.err_tip_pregleda = true;
			this.err_tip_pregleda_poruka = 'Morate definisati polje Broj zapisa.';
			M.toast({html: this.err_tip_pregleda_poruka, displayLength : this.toastTimeout});
			return;
		}
		this.err_tip_pregleda = false;
		this.err_tip_pregleda_poruka = '';

		if (!this.pregled.br_zap) {
			this.err_brojZap = true;
			this.err_brojZap_poruka = 'Morate definisati polje Broj zapisa.';
			M.toast({html: this.err_brojZap_poruka, displayLength : this.toastTimeout});
			return;
		}
		this.err_brojZap = false;
		this.err_brojZap_poruka = '';

		if (!this.pregled.datum) {
			this.err_datum = true;
			this.err_datum_poruka = 'Morate definisati polje Datum.';
			M.toast({html: this.err_datum_poruka, displayLength : this.toastTimeout});
			return;
		}

		var date = moment(this.pregled.datum, 'DD.MM.YYYY', true);
		
		if (!date || !date.isValid()){
			this.err_datum = true;
			this.err_datum_poruka = 'Polje Datum nije valjano formatirano. Unesite datum u formatu dd.mm.gggg. Npr. 31.12.2022';
			M.toast({html: this.err_datum_poruka, displayLength : this.toastTimeout});
			return;
		}

		this.err_datum = false;
		this.err_datum_poruka = '';


		let url = 'vlasnici/vozilo/pregled/dodaj';
		if (this.id){
			url = 'vlasnici/vozilo/pregled/izmijeni';
		}

		this.loading = true;
		this.pregled.auto_id = this.autoId;

		setTimeout(() => {				
		
			this.http.post(url, this.pregled)
				.subscribe(data => {
					this.msg = data;
					//console.log(data);
					this.loading = false;

					if (this.msg.id == 1) {
						if (!this.id) this.pregled.id = this.msg.newId;
						
						//let markaObj = this.marke.find((item) => item.id == this.vozilo.idMarka);
						//if (markaObj) this.vozilo.nazivMarka = markaObj.naziv; 

						if (this.onInsertPregled)
							this.onInsertPregled.emit(this.pregled);
					}
					else {
						//this.globalSrvc.showErrorModal(this.msg.text);
						M.toast({html:this.msg.text, displayLength : this.toastTimeout});
					}
				}
				, error => {
					this.loading = false;
					//this.globalSrvc.showGenericErrorModal();
				}
			);
		}, 1000);
	}

	dodajProizvodjacaTaho(){
		this.nazivSifrarnika = "tah_maker";
		this.openSifrarnikModal();	
	}

	dodajUredjajZaMjerenjeBrzine(){
		this.nazivSifrarnika = "etal_uredjaj";
		this.openSifrarnikModal();	
	}

	dodajUredjajSatniMehanizam(){
		this.nazivSifrarnika = "etal_sat_meh";
		this.openSifrarnikModal();	
	}

	dodajTehnicara(){
		this.nazivSifrarnika = "tehnicar";
		this.openSifrarnikModal();	
	}

	dodajVrstuPregleda(){
		this.nazivSifrarnika = "vrsta_pregleda";
		this.openSifrarnikModal();	
	}

	dodajSvrhuDigKalib(){
		this.nazivSifrarnika = "svrha_dig_pregleda";
		this.openSifrarnikModal();	
	}

	dodajKarticuTehnicara(){
		this.nazivSifrarnika = "kartica_tehnicara";
		this.openSifrarnikModal();	
	}

	openSifrarnikModal(){
		var elem = document.getElementById('modalsifrarnikpregled');					
		this.modalInstance = M.Modal.init(elem, {onCloseEnd : () => {}});
		this.modalInstance.open();
	}

	onInsertSifrarnik(obj){
		if (this.modalInstance) this.modalInstance.close();
		if (!obj || !obj.id) return;
		
		let arr = null;
		if (this.nazivSifrarnika == "tah_maker") arr = this.tahmakers;
		if (this.nazivSifrarnika == "etal_uredjaj") arr = this.etal_uredjaji;		
		if (this.nazivSifrarnika == "etal_sat_meh") arr = this.etal_sat_mehi;
		if (this.nazivSifrarnika == "tehnicar") arr = this.tehnicari;
		if (this.nazivSifrarnika == "vrsta_pregleda") arr = this.vrste_pregleda;
		if (this.nazivSifrarnika == "svrha_dig_pregleda") arr = this.svrhe_dig_predleda;
		if (this.nazivSifrarnika == "kartica_tehnicara") arr = this.kartice_tehnicara;
		if (!arr) return;

		arr.push(obj);
		arr.sort((a,b) => (a.naziv < b.naziv)?-1:1);
		
		if (this.nazivSifrarnika == "tah_maker") this.pregled.tahMakerId = obj.id;	
		if (this.nazivSifrarnika == "etal_uredjaj") this.pregled.etal_uredjaj_id = obj.id;
		if (this.nazivSifrarnika == "etal_sat_meh") this.pregled.etal_sat_meh_id = obj.id;
		if (this.nazivSifrarnika == "tehnicar") this.pregled.tehnicar_id = obj.id;
		if (this.nazivSifrarnika == "vrsta_pregleda") this.pregled.vrsta_pregleda_id = obj.id;
		if (this.nazivSifrarnika == "svrha_dig_pregleda") this.pregled.svrha_dig_pregleda_id = obj.id;
		if (this.nazivSifrarnika == "kartica_tehnicara") this.pregled.kartica_tehnicara_id = obj.id;
	}

	onCancelSifrarnik(){		
		if (this.modalInstance) this.modalInstance.close();
	}

}
